export const not = (a = [], b) => {
    return a.filter((item) => b.indexOf(item) === -1);
};
export const intersection = (a = [], b) => {
    return a.filter((item) => b.indexOf(item) !== -1);
};
export const union = (a = [], b) => {
    return [...a, ...not(b, a)];
};
export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};
export const groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
};
export const addSpaceBeforeCapitalLetters = (value) => value ? value.replace(/([A-Z]+)/g, ' $1').trim() : '';
export const addSpaceBeforeNumber = (value) => value ? value.replace(/[^0-9](?=[0-9])/g, '$& ').trim() : '';
// when comparing objects, take a notice that they sorted correctly
export const areObjectsSame = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);
export const mapToValueLabel = (data) => {
    return data.map((d) => ({ value: d.id, label: d.name }));
};
export const mapToStringValueLabel = (data) => {
    return data.map((d) => ({ value: d.name, label: d.name }));
};
export function addElementToArray(array, element, setState) {
    const indexOfArray = array.indexOf(element);
    if (indexOfArray === -1) {
        setState((prev) => [...new Set([...prev, element])]);
    }
}
export function removeElementFromArray(array, element, setState) {
    const indexOfArray = array.indexOf(element);
    if (indexOfArray > -1) {
        setState((prev) => prev.filter((item) => item !== element));
    }
}
